import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['county', 'organization', 'venue'];

  connect() {
    this.bindSelect2();
    this.autoSelectSelectedOptions();
  }

  bindSelect2() {
    if (this.hasCountyTarget) this.bindSelect2ForCounty();
    if (this.hasOrganizationTarget) this.bindSelect2ForTarget(this.organizationTarget);
    if (this.hasVenueTarget) this.bindSelect2ForTarget(this.venueTarget);
  }

  bindSelect2ForCounty() {
    $(this.countyTarget).select2({
      width: '100%',
      ajax: {
        url: '/counties/load',
        dataType: 'json',
        data: (params) => ({
          q: {
            name_cont: params.term,
          },
          page: params.page || 1,
        }),
        processResults: (data, params) => {
          // eslint-disable-next-line no-param-reassign
          params.page = data.page || 1;
          return {
            results: $.map(data.data, (county) => ({
              text: county.attributes.name,
              id: county.attributes.id,
            })),
            pagination: {
              more: data.links[0]?.next,
            },
          };
        },
        cache: false,
      },
    });
    this.bindSelect2Change($(this.countyTarget));
  }

  bindSelect2ForTarget(target) {
    if (target) {
      $(target).select2({
        width: '100%',
        placeholder: 'Select an option',
      });
      this.bindSelect2Change($(target));
    }
  }

  updateOrganizations(clearVenue = true) {
    Rails.ajax({
      type: 'GET',
      url: `/counties/${this.countyTarget.value}/organizations`,
      dataType: 'json',
      success: (data) => {
        const selectedOrganization = parseInt(this.organizationTarget.value, 10);
        const addPlaceholder = clearVenue || !selectedOrganization;

        $(this.organizationTarget).empty().trigger('change');
        if (clearVenue) $(this.venueTarget).empty().trigger('change');

        if (addPlaceholder) {
          // Add a placeholder option as the first option
          const placeholderOption = new Option('Select an option', '', true, false);
          $(this.organizationTarget).append(placeholderOption);
        }

        const options = data.map((element) => (
          new Option(element[0], element[1], false, selectedOrganization === element[1])
        ));

        $(this.organizationTarget).append(options).trigger('change');
      },
    });
  }

  updateVenues(addPlaceholder = true) {
    Rails.ajax({
      type: 'GET',
      url: `/organizations/${this.organizationTarget.value}/venue_json`,
      dataType: 'json',
      success: (data) => {
        const selectedVenue = parseInt(this.venueTarget.value, 10);
        $(this.venueTarget).empty().trigger('change');

        if (addPlaceholder) {
          // Add a placeholder option as the first option
          const placeholderOption = new Option('Select an option', '', true, false);
          $(this.venueTarget).append(placeholderOption);
        }

        const options = data.map((element) => (
          new Option(element[0], element[1], false, selectedVenue === element[1])
        ));

        $(this.venueTarget).append(options).trigger('change');
      },
    });
  }

  autoSelectSelectedOptions() {
    if (this.hasCountyTarget && this.countyTarget.value) {
      this.updateOrganizations(false);
    }

    if (this.hasOrganizationTarget && this.organizationTarget.value) {
      this.updateVenues(false);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  bindSelect2Change(element) {
    element.on('select2:select', (e) => {
      const event = new Event('change', { bubbles: true });
      e.target.dispatchEvent(event);
    });
  }
}
